/**
 * AnalyticsSection — Composes all analytics components into a cohesive section.
 *
 * Combines: AnalyticsFreshnessBar + AnalyticsChartTabs + TradingPatterns.
 * Provides a unified analytics experience on the token detail page.
 *
 * Story 8.5 — Task 4
 */

import { usePriceHistory } from "../../hooks/api/use-price-history";
import { useTradeHistory } from "../../hooks/api/use-trade-history";
import { AnalyticsChartTabs } from "./AnalyticsChartTabs";
import { AnalyticsFreshnessBar } from "./AnalyticsFreshnessBar";
import { TradingPatterns } from "./TradingPatterns";

type AnalyticsSectionProps = {
	tokenId: string;
};

export function AnalyticsSection({ tokenId }: AnalyticsSectionProps) {
	const priceHistory = usePriceHistory(tokenId, "1D");
	const tradeHistory = useTradeHistory(tokenId);

	const sources = [];
	if (priceHistory.data?.meta) {
		sources.push({
			name: "Price",
			dataSource: priceHistory.data.meta.dataSource,
			dataAge: priceHistory.data.meta.dataAge,
		});
	}
	if (tradeHistory.data?.meta) {
		sources.push({
			name: "Trades",
			dataSource: tradeHistory.data.meta.dataSource,
			dataAge: tradeHistory.data.meta.dataAge,
		});
	}

	return (
		<div className="space-y-4">
			<div className="flex items-center justify-between">
				<h3 className="text-lg font-semibold text-pastel-black">Analytics</h3>
				{sources.length > 0 && <AnalyticsFreshnessBar sources={sources} />}
			</div>
			<AnalyticsChartTabs tokenId={tokenId} />
			<TradingPatterns tokenId={tokenId} />
		</div>
	);
}
